import { MAX_CHILDREN } from '@sonifi/wb-guest-request/constants/wbGuestRequestConstants';
import { buildPlainNodesfromMenu } from '@sonifi/wb-tree/utils/helper';
import { MENU_STYLE } from '../../constants/wbHDContansts';
import { isBranch } from '../../store/hotelDirectorySliceHelper';

const screenIsMissingRequiredContent = (item) =>
  item.active &&
  item.screen.regions.some(
    (region) =>
      region.type === 'service_link' && !region.content.service_link.target,
  );

export const verifyCompendiaStructure =
  ({ superStrict }) =>
    (_, getState) => {
      const {
        hotelDirectory: { compendiaMenu, menuStyle },
      } = getState();

      try {
        const notifications = { errors: [], warnings: [] };
        let compendiumHasMenuLinkImages = false;
        const strictnessTarget = superStrict
          ? notifications.errors
          : notifications.warnings;

        if (superStrict && !compendiaMenu.menu.active) {
          notifications.errors.push(
            'Publishing requires at least one screen to be active.',
          );
        }

        const plainMenuNodes = buildPlainNodesfromMenu({
          menu: compendiaMenu.menu,
          init: true,
        });

        for (const item of plainMenuNodes) {
          // check for non-menus with childrens
          if (
            item.screen &&
            item.children &&
            !isBranch(item) &&
            item.children.length > 0
          ) {
            notifications.errors.push(
              `${item.screen.title}: An error happened and there are screens assigned to this ` +
              'screen. Tip! Change the screen type back to a menu screen.',
            );
          }

          // check for deleted screens
          if (item.screen.isZombie) {
            notifications.errors.push(
              'An error happened and a screen has been deleted. Tip! Move connected screens as ' +
              'necessary and delete the screen.',
            );
          }

          if (item.active && item.hasDeletedContent) {
            strictnessTarget.push(
              `${item.screen.title}: References deleted content that should be properly ` +
              'removed before publishing.',
            );
          }

          if (screenIsMissingRequiredContent(item)) {
            strictnessTarget.push(
              `${item.screen.title}: Is of a type that requires content selection, but no ` +
              'content is assigned.',
            );
          }

          if (
            item.active &&
            notifications.warnings.length === 0 &&
            menuStyle === MENU_STYLE.horizontal
          ) {
            const screenHasMenuLinkImage = item.screen.regions
              .filter((region) => region.type === 'menu_link')
              .some((region) => region.content.some((c) => !!c.image));

            compendiumHasMenuLinkImages =
              compendiumHasMenuLinkImages || screenHasMenuLinkImage;

            if (compendiumHasMenuLinkImages !== screenHasMenuLinkImage) {
              notifications.warnings.push(
                'A menu screen has a combination of images with text and text only. Please verify that the menu looks correct prior to publishing.',
              );
            }
          }

          if (item.active && isBranch(item)) {
            const activeCount = item.children?.filter(
              (item) => item.active,
            ).length;

            if (activeCount > MAX_CHILDREN) {
              notifications.errors.push(
                `${item.screen.title}: Has ${activeCount} active children, but only ${MAX_CHILDREN} are supported by the '${menuStyle}' menu style.`,
              );
            }
          }
        }
        return notifications;
      } catch (error) {
        console.error(error);
      }
    };

export const verifyRegionText = (text) => {
  const textParsed = text === '\n' ? '' : text; // Make sure to not save empty lines
  return textParsed;
};
